<div class="modal-body text-center">
    <p translate>Are you sure you want to hide this reply?</p>
    <form #hideReplyForm="ngForm">
        <div class="form-group">
            <label class="checkbox__label checkbox__label--size-small" for="isUserBlocked">
                {{ 'Hide all post/comments from this user' | translate }}
                <input type="checkbox" id="isUserBlocked" name="isUserBlocked" required [(ngModel)]="isUserBlocked" />
                <span class="checkbox__checkmark"></span>
            </label>
        </div>
    </form>
    <button type="button" class="btn btn-default" (click)="decline()" translate>Cancel</button>
    <button type="button" class="btn btn-primary ms-2" (click)="confirm()" translate>Hide</button>
</div>
